import * as moment from 'moment';
import { getReferenceDataById } from '../../functions/get-reference-data-by-id';
import { IReferenceData } from '../../interfaces/form/reference-data.model';


export class SudentRelatedEventsModel {
    caseactionsk: string;
    caseactionType: string;
    notes: string;
    formJson: string;
    eventType: string;
    relatedAction: IReferenceData;
    relatedActionDate: Date;
    previousAttempts: number;
    dateOccurred: Date;
    timeOccurred: any;
    from: string;
    to: string;
    contactMethod: IReferenceData;
    toPhone: string;
    responseMethod: IReferenceData;
    engagementStatus: IReferenceData;
    language: IReferenceData;
    languageSupportProvided: string;
    toEmailAddress: string;
    toPostalAddress: string;
    fromPhone: string;
    fromPostalAddress: string;
    fromEmailAddress: string;
    eIOutreachToFrom: IReferenceData;
    eIOutreachToFromOther: string;
    relatedActionOther: string;
    constructor(data: any, refernceData: any) {
        this.caseactionsk = data?.caseactionsk;
        this.caseactionType = data?.caseactionType;
        this.notes = data?.notes;
        this.eventType = data?.eventType;
        this.contactMethod = getReferenceDataById(data?.contactMethod?.id, refernceData.outreachMethod);
        this.responseMethod = getReferenceDataById(data?.responseMethod?.id, refernceData.outreachMethod);
        this.engagementStatus = getReferenceDataById(data?.engagementStatus?.id, refernceData.engagementstatus);
        this.language = getReferenceDataById(data?.language?.id, refernceData.language);
        this.relatedAction = getReferenceDataById(data?.relatedAction?.id, refernceData.outreachType);
        this.eIOutreachToFrom = getReferenceDataById(data?.eIOutreachToFrom?.id, refernceData.eIOutreachToFrom);
        if (data?.relatedActionDate !== null) {
            this.relatedActionDate = moment(data?.relatedActionDate).toDate();
        }
        this.previousAttempts = data?.previousAttempts;
        if (data?.dateOccurred !== null) {
            this.dateOccurred = moment(data?.dateOccurred).toDate();
        }
        this.from = data?.from;
        this.to = data?.to;
        this.toPhone = data?.toPhone;
        this.languageSupportProvided = data?.languageSupportProvided;
        if (data?.timeOccurred !== null) {
            this.timeOccurred = new Date(data?.timeOccurred);
        }
        this.toEmailAddress = data?.toEmailAddress;
        this.toPostalAddress = data?.toPostalAddress;
        this.fromPhone = data?.fromPhone;
        this.fromPostalAddress = data?.fromPostalAddress;
        this.fromEmailAddress = data?.fromEmailAddress;
        this.eIOutreachToFromOther = data?.eIOutreachToFromOther;
        this.relatedActionOther = data?.relatedActionOther
    }
    get id(): string {
        return this.caseactionsk
    }
}